import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/fieldset/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.17_@types+react@19.2.14_next@16.2.10_@babel+core_1c99dd1ddfc95e573c64b9ab02d9f8b9/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.17_@types+react@19.2.14_next@16.2.10_@babel+core_1c99dd1ddfc95e573c64b9ab02d9f8b9/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.17_@types+react@19.2.14_next@16.2.10_@babel+core_1c99dd1ddfc95e573c64b9ab02d9f8b9/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.17_@types+react@19.2.14_next@16.2.10_@babel+core_1c99dd1ddfc95e573c64b9ab02d9f8b9/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.10_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0_007fd9794b15fb4d8befbba8276f2b8b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FieldControl"] */ "/opt/build/repo/packages/react/src/field/control/FieldControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldDescription"] */ "/opt/build/repo/packages/react/src/field/description/FieldDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldError"] */ "/opt/build/repo/packages/react/src/field/error/FieldError.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldItem"] */ "/opt/build/repo/packages/react/src/field/item/FieldItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldLabel"] */ "/opt/build/repo/packages/react/src/field/label/FieldLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldRoot"] */ "/opt/build/repo/packages/react/src/field/root/FieldRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldValidity"] */ "/opt/build/repo/packages/react/src/field/validity/FieldValidity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldsetLegend"] */ "/opt/build/repo/packages/react/src/fieldset/legend/FieldsetLegend.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FieldsetRoot"] */ "/opt/build/repo/packages/react/src/fieldset/root/FieldsetRoot.tsx");
